<template>
  <div>
    <div style="margin: 5px 0 5px 0;">
      <component :is="'type-' + item.type[0].replace(/_/g, '-')"
                 v-model="dd"
                 :list="item['options']"
                 :disabled="disabled"
                 :multiple="item['list']||false" />
    </div>
  </div>
</template>
<script>
import TypeCompany from './TypeCompany'
import TypeString from './TypeString'
import TypeText from './TypeText'
import TypeInt from './TypeInt'
import TypeName from './TypeName'
import TypeDate from './TypeDate'
import TypeRangeAge from './TypeRangeAge'
import TypeRangeInt from './TypeRangeInt'
import TypeLargeAmount from './TypeLargeAmount'
import TypeAge from './TypeAge'
import TypeYear from './TypeYear'
import TypePeriodsAndAges from './TypePeriodsAndAges'
import TypePeriod from './TypePeriod'
import TypeArea from './TypeArea'
import TypeRate from './TypeRate'
import TypeRangeYearRate from './TypeRangeYearRate'
import TypeRangeAgeLargeAmount from './TypeRangeAgeLargeAmount'
import TypeFeeList from './TypeFeeList'
import TypeFile from './TypeFile'
import TypeImage from './TypeImage'

export default {
  name: "ProductItemContent",
  components: {
    TypeImage,
    TypeFile,
    TypeCompany,
    TypeString,
    TypeDate,
    TypeRangeAge,
    TypeName,
    TypeInt,
    TypeLargeAmount,
    TypeAge,
    TypePeriod,
    TypeArea,
    TypeRangeInt,
    TypeRate,
    TypeText,
    TypePeriodsAndAges,
    TypeRangeYearRate,
    TypeRangeAgeLargeAmount,
    TypeFeeList,
    TypeYear
  },
  data() {
    return {
    }
  },
  props: {
    item: {
      type: Object,
      default: () => { return {} }
    },
    id: {
      type: String,
      default: () => ''
    },
    value: [String, Number, Array, Object],
    disabled: Boolean
  },
  computed: {
    dd: {
      get: function () { return this.value },
      set: function (n) { this.$emit('input', n, this.id) }
    }
  },
}
</script>